export default __webpack_public_path__ + "static/media/je.09abe97b.svg";